<template>
    <v-dialog v-model="dialog" width="500px">
        <v-card>
            <v-card-title :class="getClass()" style="font-weight:bold; color:white">
                <span v-if="!can_delete&&can_edit">Edit restriction</span>
                <span v-if="can_delete&&!can_edit">Confirm delete restriction</span>
                <span v-if="can_delete&&can_edit">Edit or delete restiction</span>
            </v-card-title>
            <v-card-text>
                <v-row v-if="hprs.huis_combi > ''" no-gutters>
                    <v-col class="ma-2">
                        <v-alert border="left" type="warning">Attention: Combi Accommodation</v-alert>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col class="ma-2">
                        <br/>Restriction: {{hprs.plrstaal_oms}} 
                        <br/>
                        <br/>Booking date: {{hprs.hprs_boek}} 
                        <br/>Stay date: {{hprs.hprs_verb}} 
                        <br/>
                        <br/>Update or delete this restriction
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="6" class="pa-2">
                        <date_picker label="Date from" :date="hprs.hprs_verb_van_dat" :startDate="hprs.hprs_verb_van_dat" field="hprs_verb_van_dat" icon="mdi-calendar-month-outline" @updateData="updateData"/> 
                    </v-col>
                    <v-col cols="6" class="pa-2">
                        <date_picker label="Date until" :date="hprs.hprs_verb_tm_dat" :startDate="hprs.hprs_verb_tm_dat" field="hprs_verb_tm_dat" icon="mdi-calendar-month-outline" @updateData="updateData"/> 
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-btn color="error"   class="mx-2" small @click="rmHprs" v-if="hprs.hprs_allow_remove&&can_delete">Delete</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" class="mx-2" small @click="updRmvHprs" v-if="hprs.hprs_allow_edit&&can_edit">Update</v-btn>
                <v-btn color="success" class="mx-2" small @click="closeDialog(false)">Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import date_picker from "@/components/ui/date_picker.vue";

    export default {
        components: {
            date_picker,
        },
        data() { 
            return {
                dialog: false,
                can_edit: false, 
                can_delete: false,
                hprs_verb_van_dat: "",
                hprs: {}
            }
        },
        methods: {
            getClass() {
                if (this.can_delete) return "error headline";
                return "primary headline";
            },
            openDialog(hprs_encrid, huis_encrid, can_edit, can_delete) {
                this.can_edit = can_edit;
                this.can_delete = can_delete;
                this.$axios.post("ares/json/ares/huis/hspl/getHprs.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getHprs"
                    },
                    getHprs: {
                        hprs_encrid: hprs_encrid,
                        huis_encrid: huis_encrid
                    }
                }).then(res => {
                    if (res.data.error) {
                        // console.log(res.data.error);
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.error.message,
                            color: "error"
                        });
                    } else {
                        this.hprs = res.data.getHprs;
                        this.hprs_verb_van_dat = this.hprs.hprs_verb_van_dat;
                        this.dialog = true;
                    }
                });
            },
            updateData(data) {
                console.log(data)
                this.hprs[data.field] = data.value;
            },
            closeDialog(refresh) {
                if (refresh) {
                    this.$emit("reloadHuis");
                }
                this.dialog = false;
            },
            updHprs() { 
                console.log("updHprs");
                this.closeDialog(true);
            },
            updRmvHprs() { 
                this.$axios.post("ares/json/ares/huis/hspl/updRmvHprs.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "updRmvHprs"
                    },
                    updRmvHprs: {
                        hprs_encrid: this.hprs.hprs_encrid,
                        hprs_verb_van_dat: this.hprs.hprs_verb_van_dat,
                        hprs_verb_tm_dat: this.hprs.hprs_verb_tm_dat
                    }
                }).then(res => {
                    if (res.data.error) {
                        //console.log(res.data.error);
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.error.message,
                            color: "error"
                        });
                    }  else { 
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.updRmvHprs.text,
                            color: res.data.updRmvHprs.color
                        });
                        this.closeDialog(true);
                    }
                })
            },
            rmHprs() { 
                this.$axios.post("ares/json/ares/huis/hspl/rmHprs.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "rmHprs"
                    },
                    rmHprs: {
                        hprs_encrid: this.hprs.hprs_encrid,
                        huis_encrid: this.hprs.huis_encrid
                    }
                }).then(res => {
                    if (res.data.error) {
                        //console.log(res.data.error);
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.error.message,
                            color: "error"
                        });
                    }  else { 
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.rmHprs.text,
                            color: res.data.rmHprs.color
                        });
                        this.closeDialog(true);
                    }
                })
            },
        }
    }
</script>

